const mediaMatch = {
  matcher: /dailymotion.com\/video\/(.*)\/?(.*)/,
  url: 'https://www.dailymotion.com/embed/video/$1',
};

export default { mediaMatch };
